import { Action } from 'redux';
import { isString } from 'util';

import { RequestFailed } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export const dismissDialogReasons = ['cancel', 'closeX', 'esc key press', 'backdrop click', 'location change'];

export class Failure {
  private _reason: string;
  private _error: Error;

  constructor(reason: string | Error) {
    if (isString(reason)) {
      this._reason = reason as string;
    } else {
      this._error = reason as Error;
    }
  }

  public get reason(): string {
    return this._reason;
  }

  public get error(): Error {
    return this._error;
  }

  public get isDismissDialog(): boolean {
    return dismissDialogReasons.indexOf(this.reason) > -1;
  }
}

export interface RequestFailedAction extends Action {
  failure: Failure;
  localizedMessage?: string;
}

export function requestFailed(reason: string, localizedMessage?: string): RequestFailedAction;
export function requestFailed(error: Error, localizedMessage?: string): RequestFailedAction;
export function requestFailed(reason: string | Error, localizedMessage?: string): RequestFailedAction {
  const failure = new Failure(reason);
  return {
    type: RequestFailed,
    failure,
    localizedMessage,
  };
}

export const isRequestFailed = isActionFactory<RequestFailedAction>(RequestFailed);
